<template>
	<div
		v-if="collection && collection.items && collection.items.length"
		class="collection-lane l-content-section -extra-spacing"
		:class="{ '-centered': centerHorizontally }"
	>
		<SectionTitle
			v-if="showTitle && collection.title"
			:title="collection.title"
			:align-center="centerHorizontally"
		/>
		<SectionTitle
			v-if="collection.subtitle"
			type="sm"
			:title="collection.subtitle"
			:align-center="centerHorizontally"
		/>
		<Carousel
			ref="carousel"
			:cells="items"
			:image-carousel="true"
			:center-horizontally="centerHorizontally"
		>
			<template #cell="{cell}">
				<component
					:is="cell.link ? 'a' : 'div'"
					:href="cell.link || null"
					:target="cell.link ? (mixinIsExternalLink(cell.link) ? '_blank' : '_self') : null"
					:rel="cell.link ? 'nofollow noopener' : null"
					class="collection-lane__item"
				>
					<img
						v-if="cell.imageUrl"
						:src="cell.imageUrl"
						:alt="collection.title || ''"
						class="collection-lane__image"
						:style="{ height: getImageHeight(cell.id) }"
						@load="handleImageLoad($event, cell.id)"
					>
				</component>
			</template>
		</Carousel>
	</div>
</template>

<script>
import Carousel from '@js/components/Carousel';
import SectionTitle from '@js/components/SectionTitle';

export default {
	name:       'CollectionLane',
	components: { Carousel, SectionTitle },
	props:      {
		collection: {
			type:     Object,
			required: true,
		},
		centerHorizontally: {
			type:    Boolean,
			default: false,
		},
	},
	data() {
		return {
			imageHeights: {},
		};
	},
	computed: {
		showTitle() {
			return this.collection?.showTitle ?? true;
		},
		items() {
			return this.collection?.items || [];
		},
	},
	methods: {
		handleImageLoad(event, itemId) {
			const img = event.target;
			const naturalHeight = img.naturalHeight;

			// Always display at half size (retina) - max 512px
			const targetHeight = Math.min(naturalHeight / 2, 512);

			this.$set(this.imageHeights, itemId, `${targetHeight}px`);

			// Rerender carousel after image loads
			this.$nextTick(() => {
				if (this.$refs.carousel?.rerender) {
					this.$refs.carousel.rerender();
				}
			});
		},
		getImageHeight(itemId) {
			return this.imageHeights[itemId] || 'auto';
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@sass/variables';

// .collection-lane {}

.collection-lane__item {
	padding: $carousel-card-overflow;
}

a.collection-lane__item img { // stylelint-disable-line
	transition: transform $trans-time-fast;
	transform: scale(1);

	&:hover { // stylelint-disable-line
		transform: scale(1.05);
	}
}

.collection-lane__image {
	display: block;
	width: auto;
	height: auto;
	max-height: 512px;
	max-width: none;
	object-fit: contain;
	border-radius: var(--t-border-radius-card--lg);
}
</style>
